<template>
	<el-main>
		<SolutionBanner :dataimgs="dataimgs" />
		<SolutionMain :data="solutionMains" />
		<Experience />
	</el-main>
</template>

<script>
	import SolutionBanner from './SolutionBanner'
	import SolutionMain from './SolutionMain'
	export default {
		name: 'SolutionFinance',
		components: {
			SolutionBanner,
			SolutionMain,
		},
		data() {
			return {
				dataimgs: [{
					src1: require('@/assets/images/bankbanner.jpg'),
					src2: require('@/assets/images/bankbanner-m.png'),
					title: '金融行业运维解决方案',
					content: ['基于“管理+技术”理念开发的云服务可靠性工程', '满足了95%金融客户对7*24服务不间断的运维需求'],
					btn: '立即咨询',
					url:'http://wpa.qq.com/msgrd?v=3&uin=2629198267&site=qq&menu=yes'
				}],
				solutionMains: [{
					id: 0,
					title: '方案概述',
					contents: [{
						content: ['以“管理+技术” 的双维模型，构建高效的运维管理体系，是本方案的核心理念。']
					}, {
						content: [
							'整体解决方案以满足用户“开放式、轻量级、业务型”的通用型业务需求。针对有7x24的生产线环境的运维需求而设计开发，其目标是提高生产线的服务可用度（service reliability），成本效益（cost efficiency）， 运维效率（operation productivity） 和用户体验（user experiences）。'
						]
					}],
					src: require('@/assets/images/bank-top.png')
				}, {
					id: 1,
					title: '系统架构',
					contents: [{
						title: '系统主要内容包括2个子系统：',
						content: ['（1）运营管理子系统<br/>（2）配置管理（CMDB）子系统']
					}, {
						title: '运营管理子系统',
						content: ['自定义能力，包括流程步骤和流程表单的自定义']
					}, {
						title: '配置管理子系统（CMDB）',
						content: ['自定义各种模型元件，以及模型元件之间逻辑关系。实现自定义资源模型、资源以及资源池管理。通过动态分组和标签管理来有效的标识业务和资源之间的关系。自动发现和展示关系拓扑。',
							'CMDB为用户提供了灵活的配置管理工具，通过自定义模型功能使客户将全部核心配置都有效的管理起来，并且能够同步给业务流程使用并更新。'
						]
					}],
					src: require('@/assets/images/bank.png')
				}]
			}
		}
	}
</script>

<style>
	@media (max-width:992px) {}

	@media (min-width:992px) {}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SolutionFinance.vue